import React       from 'react';
import ReactDom    from 'react-dom';
import Moment      from 'moment';

import Const       from 'fw_const';
import Utils       from 'utils';
import {Tooltip}        from 'pui-react-tooltip';
import {OverlayTrigger} from 'pui-react-overlay-trigger';

// -------------------------------------------------------


class SummaryMainScore extends React.Component {
  render() {
    let data = this.props.data;
    let workflow = data.workflow;
    
    
    let influencer_count = Object.keys(workflow.influencers).length;
    
    let assign_count = 0;
    for( let i in workflow.influencers ){ try { if( workflow.influencers[i].status.is_assign === 1 ) assign_count++; } catch(e) {} }
    
    let postAry = [];
    data.report.list.map((d) => { if( postAry.indexOf(d.insta_user_id) == -1 ) postAry.push(d.insta_user_id); });
    
    let report_count = postAry.length;
    let report_percent = Math.round((report_count / influencer_count) * 100);
    if( isNaN(report_percent) || report_percent == 'Infinity' ) report_percent = 0;
    
    let reply_count = 0;
    let reply = 0;
    
    let permission_count = 0;
    let permission = 0;
    
    let items = [
      { id: 'influencers', name: 'インフルエンサー人数', value: influencer_count, type: 'person' },
      { id: 'survival',    name: 'レポート投稿人数',     value: report_percent,   type: 'percent', count: report_count,     help: <p>キャンペーン内の全候補者（候補者、対象外、アサイン対象の合計）<br />に対する「アサイン対象人数」を割った残り候補者の割合</p> },
      { id: 'reply',       name: '未定',                 value: reply,            type: 'percent', count: reply_count,      help: <p>アサイン対象者に対して「何かしらの返信があった人数」の割合<br />（辞退連絡等も含む）</p> },
      { id: 'permission',  name: '未定',                 value: permission,       type: 'percent', count: permission_count, help: <p>アサイン対象者に対して「案件OK人数」の割合<br />（ワークフローで「2.投稿まで」以降のユーザーが対象）</p> },
    ];
    
    return (
      <div className="report-main-score">
        { items.map((d, key) => {
          return (
            <div key={key} className="score-item">
              <h3>
                <span>{d.name}</span>
                { (d.help != undefined) &&
                  <OverlayTrigger key={key} placement="top" delayShow={50} overlay={<Tooltip>{d.help}</Tooltip>}>
                    <i className="material-icons">info</i>
                  </OverlayTrigger>
                }
              </h3>
              <h4>
                {d.value}
                {(d.type == 'percent') ? <span>%</span> : <span>人</span>}
              </h4>
              {(d.count != undefined) && <h5>({d.count}人)</h5> }
            </div>
          );
        })}
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default SummaryMainScore;